const pause = (duration) => new Promise((res) => setTimeout(res, duration));

// Applies back retry logic to a given function fn that is of type Promise
const withRetry = ({
  retries = 1,
  fn,
  delay = 500,
  backOffCoefficient = 2,
  onRetry = () => {},
  onFailed = () => {},
  onSuccess,
}) =>
  fn()
    .then((res) => onSuccess && onSuccess(res))
    .catch((err) =>
      retries > 0
        ? pause(delay).then(() => {
            if (onRetry) {
              onRetry();
            }

            return withRetry({
              retries: retries - 1,
              fn,
              delay: delay * backOffCoefficient,
              backOffCoefficient,
              onRetry,
              onFailed,
              onSuccess,
            });
          })
        : onFailed && onFailed(err)
    );

export default withRetry;
try {
    // @ts-ignore
    retry.displayName = "retry";
    // @ts-ignore
    retry.__docgenInfo = { "description": "", "displayName": "retry", "props": { "retries": { "defaultValue": { value: 1 }, "description": "", "name": "retries", "required": false, "type": { "name": "number" } }, "fn": { "defaultValue": null, "description": "", "name": "fn", "required": true, "type": { "name": "any" } }, "delay": { "defaultValue": { value: 500 }, "description": "", "name": "delay", "required": false, "type": { "name": "number" } }, "backOffCoefficient": { "defaultValue": { value: 2 }, "description": "", "name": "backOffCoefficient", "required": false, "type": { "name": "number" } }, "onRetry": { "defaultValue": { value: "() => {}" }, "description": "", "name": "onRetry", "required": false, "type": { "name": "() => void" } }, "onFailed": { "defaultValue": { value: "() => {}" }, "description": "", "name": "onFailed", "required": false, "type": { "name": "() => void" } }, "onSuccess": { "defaultValue": null, "description": "", "name": "onSuccess", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/utils/retry.ts#retry"] = { docgenInfo: retry.__docgenInfo, name: "retry", path: "src/utils/retry.ts#retry" };
}
catch (__react_docgen_typescript_loader_error) { }